export default "__VITE_ASSET__CgPv_WK1__"